export enum ZLCLColor {
    gold = '#eda821',
    darkGrey = '#1a1a1a',
    white = '#ffffff',
    visibleGold = '#d27200',
}

export enum Grey {
    dark = 'rgba(26, 26, 26, 0.6)',
    medium = 'rgba(26, 26, 26, 0.4)',
    light = 'rgba(26, 26, 26, 0.2)',
    bright = 'rgba(26, 26, 26, 0.1)',
}
